import useBulkTemplateActions from '../../../hooks/useBulkTemplateActions';

const useActions = (templateType, selectedRows, handleAlert, tableRef) => {
	const { handleBulkAction } = useBulkTemplateActions(templateType);

	const runAction = (action) => {
		handleBulkAction(selectedRows, handleAlert, action);
		tableRef?.current?.clearSelection();
	};

	const disabled = selectedRows.length === 0;

	return {
		title: 'BULK ACTION',
		tipPlacement: 'left',
		variant: 'outlined',
		marginBottom: '0px',
		popperPlacement: 'bottom-end',
		tipTitle: 'Please Select an Item',
		options: [
			{
				disabled,
				title: 'Archive Selected',
				onClick: () => runAction('archive')
			},
			{
				disabled,
				title: 'Unarchive Selected',
				onClick: () => runAction('unarchive')
			},
			{
				disabled,
				title: 'Delete Selected',
				onClick: () => runAction('delete')
			}
		]
	};
};

export default useActions;
